export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يبحث"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أنت في وضع التجربة. الأرصدة والمعاملات تدريبية."])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الانتقال إلى الكابينة العملية"])}
}